'use client'

import { ChevronDown } from 'lucide-react'
import { useState } from 'react'

export function Select({
  children,
  className,
  ...props
}: React.SelectHTMLAttributes<HTMLSelectElement>) {
  const [isFocused, setIsFocused] = useState(false)

  return (
    <div className="grid grid-cols-1">
      <select
        className={`col-start-1 row-start-1 w-full appearance-none rounded-lg border border-gray-300 py-2 pl-3 pr-10 text-base text-gray-900 focus:border-black focus:ring-1 focus:ring-black ${className}`}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        {...props}
      >
        {children}
      </select>
      <span className="pointer-events-none col-start-1 row-start-1 mr-4 size-5 self-center justify-self-end sm:size-4">
        <ChevronDown
          className={`size-5 text-black transition-transform duration-200 ${isFocused ? 'rotate-180' : ''}`}
          aria-hidden="true"
        />
      </span>
    </div>
  )
}
